/**
 * Private member
 *
 * Send to the console any event when New Relic
 * is not available
 */
const logNewrelicUnavailable = (...args: any[]) => {
  console.warn('Unable to send event to New Relic', args);
};

/**
 * Private member
 * Mimic the New Relic methods in case
 * New Relic is not available and return a warning
 */
const newRelicStub = window.newrelic || {
  setCustomAttribute: logNewrelicUnavailable,
  addPageAction: logNewrelicUnavailable,
  noticeError: logNewrelicUnavailable,
};

export default class Monitoring {
  /**
   * Set the merchant id globally
   *
   * @param {String} mid
   */
  static setMerchantId(mid: string) {
    newRelicStub.setCustomAttribute('merchantId', mid);
  }

  /**
   * Set the shop id globally
   *
   * @param {String} sid
   */
  static setShopId(sid: string) {
    newRelicStub.setCustomAttribute('shopId', sid);
  }

  /**
   * Sends newRelic events through pageActions
   *
   * @param {String} eventName Name of the event
   * @param {String} source Where the event come from, using the Class name is recommended
   * @param {Object} cAttributes The custom attributes you want to submit with this event
   */
  static NREvent(eventName: string, source: string, cAttributes: { [key: string]: any } = {}) {
    newRelicStub.addPageAction(eventName, { source, ...cAttributes });
  }

  /**
   * Sends notice or log in case of error
   * to New Relic
   *
   * @param {Error} error object thrown when runtime errors occur
   * @param {String} source Where the event come from, using the Class name is recommended
   * @param {Object} cAttributes The custom attributes you want to submit with this event
   */
  static NRError(error: Error, source: string, cAttributes: { [key: string]: any } = {}) {
    newRelicStub.noticeError(error, { source, ...cAttributes });
  }
}

window.Monitoring = Monitoring;
